const SD = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%2085.333%20512%20341.333'%3e%3crect%20y='85.337'%20fill='%23FFFFFF'%20width='512'%20height='341.326'/%3e%3crect%20y='85.337'%20fill='%23D80027'%20width='512'%20height='113.775'/%3e%3crect%20y='312.888'%20width='512'%20height='113.775'/%3e%3cpolygon%20fill='%23496E2D'%20points='0,426.668%200,85.331%20256,256.006%20'/%3e%3c/svg%3e";
export {
  SD as default
};
//# sourceMappingURL=SD.svg.es.js.map
